module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  }, [_c('el-container', {
    staticClass: "layout jhh-layou"
  }, [_c('el-header', [_c('nav', {
    staticClass: "jhh-page-tabs"
  }, [_c('div', {
    staticClass: "fl jhh-logo el-col-4",
    staticStyle: {
      "width": "220px"
    },
    on: {
      "click": function($event) {
        return _vm.goHome()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/quanfu_logo.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "jhh-tag fl"
  }, [_c('h2', [_vm._v("您身边的手机上门快修专家")])]), _vm._v(" "), (_vm.weatherInfo) ? _c('div', {
    staticStyle: {
      "float": "left !important",
      "margin-top": "0",
      "width": "30%",
      "margin-left": "3%"
    }
  }, [_c('el-carousel', {
    attrs: {
      "height": "50px",
      "direction": "vertical",
      "autoplay": true,
      "interval": 5000,
      "indicator-position": "none"
    }
  }, _vm._l((_vm.weatherInfo.daily), function(item, index) {
    return _c('el-carousel-item', {
      key: index
    }, [_c('h3', {
      staticClass: "medium user-center"
    }, [_c('img', {
      staticStyle: {
        "border": "0",
        "vertical-align": "sub"
      },
      attrs: {
        "src": item.imageUrl,
        "alte": ""
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "position": "fixed"
      }
    }, [_c('ul', {
      staticStyle: {
        "list-style-type": "none",
        "margin": "0",
        "padding": "0"
      }
    }, [_c('li', {
      staticStyle: {
        "height": "20px",
        "line-height": "20px",
        "padding": "2px 0 0",
        "overflow": "hidden"
      }
    }, [_c('span', {}, [_vm._v(_vm._s(item.date))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.weatherInfo.location.name))])]), _vm._v(" "), _c('li', {
      staticStyle: {
        "height": "20px",
        "line-height": "20px",
        "padding": "2px 0 0",
        "overflow": "hidden"
      }
    }, [_c('span', {}, [_vm._v(_vm._s(item.textDay))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.low) + "℃~" + _vm._s(item.high) + "℃")])])])])])])
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "jhh-user fr"
  }, [_c('span', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isChangeonline),
      expression: "isChangeonline"
    }],
    staticClass: "user-welcome fl",
    staticStyle: {
      "margin-right": "50px"
    }
  }, [(_vm.isOnline == 0) ? _c('span', {
    staticClass: "offline-status",
    on: {
      "click": function($event) {
        return _vm.updateAutomaticOrderOpe(1)
      }
    }
  }, [_vm._v("离线")]) : _vm._e(), _vm._v(" "), (_vm.isOnline == 1) ? _c('span', {
    staticClass: "online-status",
    on: {
      "click": function($event) {
        return _vm.updateAutomaticOrderOpe(0)
      }
    }
  }, [_vm._v("在线")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "user-welcome fl"
  }, [_vm._v("\n                            欢迎登录," + _vm._s(_vm.hoursTip) + ","), (_vm.userName !== '') ? _c('span', [_vm._v(" " + _vm._s(_vm.roleName) + " ")]) : _vm._e()]), _vm._v(" "), (_vm.userName === 'admin') ? _c('div', {
    staticClass: "jhh-user-pic fl",
    on: {
      "click": function($event) {
        return _vm.toggleSetting()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/engineerImg.png"),
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('el-dropdown', {
    staticClass: "user-center fl",
    attrs: {
      "trigger": "click"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v("\n                                个人中心"), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.toHelp()
      }
    }
  }, [_vm._v("帮助中心")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.changePsw()
      }
    }
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改密码",
      "visible": _vm.billdialog,
      "width": "700px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.billdialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-position": _vm.labelPosition,
      "label-width": "100px",
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "登录名：",
      "prop": "loginName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": ""
    },
    model: {
      value: (_vm.form.loginName),
      callback: function($$v) {
        _vm.$set(_vm.form, "loginName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.loginName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原密码：",
      "prop": "old_password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.form.old_password),
      callback: function($$v) {
        _vm.$set(_vm.form, "old_password", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.old_password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新密码：",
      "prop": "new_password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.form.new_password),
      callback: function($$v) {
        _vm.$set(_vm.form, "new_password", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.new_password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码强度："
    }
  }, [_c('div', {
    staticClass: "isActive",
    class: {
      'isActive1': _vm.form.checkstrong === '中',
      'isActive2': _vm.form.checkstrong === '强'
    },
    domProps: {
      "textContent": _vm._s(_vm.form.checkstrong)
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认密码：",
      "prop": "new_password2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.form.new_password2),
      callback: function($$v) {
        _vm.$set(_vm.form, "new_password2", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.new_password2"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitFormPsw('form')
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.billdialog = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1), _vm._v(" "), _c('el-container', [_c('el-aside', {
    staticClass: "layout-menu-left"
  }, [_c('el-scrollbar', {
    staticStyle: {
      "height": "100%",
      "margin-bottom": "25%"
    }
  }, [_c('AppNav', {
    attrs: {
      "menus": _vm.menus
    }
  })], 1)], 1), _vm._v(" "), _c('el-container', [_c('el-main', {
    staticClass: "app-content",
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "app-wrap"
  }, [_c('div', {
    staticClass: "template-tabs"
  }, [(_vm.options.length) ? _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.tabClick,
      "tab-remove": _vm.tabRemove
    },
    model: {
      value: (_vm.activeIndex),
      callback: function($$v) {
        _vm.activeIndex = $$v
      },
      expression: "activeIndex"
    }
  }, [_vm._l((_vm.options), function(item, index) {
    return _c('el-tab-pane', {
      key: item.name,
      attrs: {
        "closable": item.name != '首页',
        "label": item.name,
        "name": item.route
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrap"
  }, [_c('keep-alive', [_c('router-view')], 1)], 1)], 2) : _vm._e()], 1), _vm._v(" "), (_vm.options.length > 1) ? _c('i', {
    staticClass: "close-content el-icon-circle-close",
    on: {
      "click": _vm.closeAll
    }
  }) : _vm._e()])]), _vm._v(" "), _c('el-footer', {
    staticStyle: {
      "margin": "0 0 0 12%"
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#F5F7F9"
    }
  }, [_c('p', {
    staticClass: "footer"
  }, [_vm._v("Copyright "), _c('a', {
    attrs: {
      "href": "https://www.hohofast.com/#/"
    }
  }, [_vm._v("上海全服通信有限公司")]), _vm._v(" © 2016-" + _vm._s(_vm.resolvingDate(new Date())) + " 版权所有 。")])])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-5a2a04ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 1673
// module chunks = 0